export default __webpack_public_path__ + "static/media/meslay2.15bcb4d2.jpg";